interface TipoBadgeProps {
  tipo: 'Ingreso' | 'Egreso';
}

export function TipoBadge({ tipo }: TipoBadgeProps) {
  const isIngreso = tipo === 'Ingreso';
  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-semibold ${isIngreso ? 'bg-blue-50 text-blue-700' : 'bg-slate-100 text-slate-600'}`}>
      <span className={`size-1.5 rounded-full ${isIngreso ? 'bg-blue-500' : 'bg-slate-400'}`} />
      {tipo}
    </span>
  );
}
